var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0.90625C0.25 0.542578 0.542578 0.25 0.90625 0.25H13.5938C13.9574 0.25 14.25 0.542578 14.25 0.90625C14.25 1.26992 13.9574 1.5625 13.5938 1.5625H0.90625C0.542578 1.5625 0.25 1.26992 0.25 0.90625ZM2.875 5.5C2.875 5.13633 3.16758 4.84375 3.53125 4.84375H7.25H10.9688C11.3324 4.84375 11.625 5.13633 11.625 5.5C11.625 5.86367 11.3324 6.15625 10.9688 6.15625H3.53125C3.16758 6.15625 2.875 5.86367 2.875 5.5ZM9 10.0938C9 10.4574 8.70742 10.75 8.34375 10.75H6.15625C5.79258 10.75 5.5 10.4574 5.5 10.0938C5.5 9.73008 5.79258 9.4375 6.15625 9.4375H8.34375C8.70742 9.4375 9 9.73008 9 10.0938Z",
    fill: "#01152E",
    stroke: "#01152E",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filter-icon.2e6fb44e24600c1f284314b693d51614.svg";
export { ForwardRef as ReactComponent };